// extracted by mini-css-extract-plugin
export default {"main":"DeliverablesTabView_main__gfz16","container":"DeliverablesTabView_container__ikfUI","emptyState":"DeliverablesTabView_emptyState__khHST font-xs-regular"};